module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"thomasliu-resume","short_name":"thomasliu-resume","start_url":"/","background_color":"hsla(0,0%,100%,.95)","theme_color":"hsla(0,0%,100%,.95)","display":"minimal-ui","icon":"src/images/truecar-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a4f353b85150efb3ae2115b52cca8c68"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
